<template>
  <ul id="context-menu" v-if="isPaste">
    <span class="close-button mdi mdi-close-circle mdi-24px" @click="closeContextMenu"></span>
    <ContextMenuItem><p class="not-copy menu-icon" @click="scenarioPaste"><span class="mdi mdi-content-paste" style="margin-right: 5px;"></span>貼り付け</p></ContextMenuItem>
    <ContextMenuItem><p class="not-copy menu-icon" @click="scenarioPastCancel"><span class="mdi mdi-cancel" style="margin-right: 5px;"></span>キャンセル</p></ContextMenuItem>
  </ul>
  <ul id="context-menu" v-else>
    <span class="close-button mdi mdi-close-circle mdi-24px" @click="closeContextMenu"></span>
    <ContextMenuItem><p class="not-copy menu-icon" @click="openEdit"><span class="mdi mdi-playlist-edit" style="margin-right: 5px;"></span>編集</p></ContextMenuItem>
    <ContextMenuItem><p class="not-copy menu-icon" @click="openDelete"><span class="mdi mdi-delete" style="margin-right: 5px;"></span>削除</p></ContextMenuItem>
    <ContextMenuItem v-if="!isRoboPartsSetView"><p class="not-copy menu-icon" @click="scenarioCopy"><span class="mdi mdi-content-copy" style="margin-right: 5px;"></span>コピー</p></ContextMenuItem>
    <ContextMenuItem v-if="!isRoboPartsSetView"><p class="not-copy menu-icon" @click="scenarioCut"><span class="mdi mdi-content-cut" style="margin-right: 5px;"></span>切り取り</p></ContextMenuItem>
    <ContextMenuItem v-if="!isRoboPartsSetView"><p class="not-copy menu-icon" @click="scenarioDuplicate"><span class="mdi mdi-content-duplicate" style="margin-right: 5px;"></span>コピペ</p></ContextMenuItem>
    <ContextMenuItem v-if="modalScenario.status !== 22 && modalScenario.status !== 100 && !isRoboPartsSetView"><p class="not-copy menu-icon" @click="startFlgSet"><span class="mdi mdi-flag" style="margin-right: 5px;"></span>開始設定</p></ContextMenuItem>
    <ContextMenuItem v-if="modalScenario.status !== 22 && modalScenario.status !== 100"><p class="not-copy menu-icon" @click="goalFlgSet"><span class="mdi mdi-map-marker" style="margin-right: 5px;"></span>終了設定</p></ContextMenuItem>
    <ContextMenuItem v-if="modalScenario.status !== 22 && modalScenario.status !== 100 && isRoboPartsSetView"><p class="not-copy menu-icon" @click="setRoboPartsSetInputFlg"><span class="mdi mdi-exit-to-app" style="margin-right: 5px;"></span>入力設定</p></ContextMenuItem>
    <!-- 日程調整パーツ(status=4)で「候補日時ない場合の分岐」が設定されている場合は出力設定が表示されないように制御を追加 3/30 -->
    <ContextMenuItem v-if="modalScenario.status !== 0 && modalScenario.status !== 3 && modalScenario.status !== 12 && modalScenario.status !== 17 && modalScenario.status !== 22 && modalScenario.status !== 100  && !(modalScenario.status === 4 && modalScenario.select.length > 1) && isRoboPartsSetView"><p class="not-copy menu-icon" @click="setRoboPartsSetOutputFlg"><span class="mdi mdi-export" style="margin-right: 5px;"></span>出力設定</p></ContextMenuItem>
  </ul>
</template>

<script>
import { mapState } from 'vuex'
import ContextMenuItem from '@/components/ui/ContextMenuItem'
export default {
  name: 'ContextMenuScenario',
  components: {
    ContextMenuItem
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('chatbot', ['isPaste', 'isRoboPartsSetView', 'scenarioTable', 'modalScenario', 'selectRoboPartsSet'])
  },
  methods: {
    openEdit () {
      console.debug('*** Start *** openEdit')
      this.$store.dispatch('chatbot/changeModalEditScenario')
      this.closeContextMenu()
      console.debug('*** End *** openEdit')
    },
    openDelete () {
      console.debug('*** Start *** openDelete')
      this.$store.dispatch('chatbot/changeModalDeleteScenario')
      this.closeContextMenu()
      console.debug('*** End *** openDelete')
    },
    scenarioCopy () {
      console.debug('*** Start *** scenarioCopy')
      this.$store.dispatch('chatbot/scenarioCopy')
      this.closeContextMenu()
      console.debug('*** End *** scenarioCopy')
    },
    scenarioCut () {
      console.debug('*** Start *** scenarioCut')
      this.$store.dispatch('chatbot/scenarioCut')
      this.closeContextMenu()
      console.debug('*** End *** scenarioCut')
    },
    scenarioPaste () {
      console.debug('*** Start *** scenarioPaste')
      this.$store.dispatch('chatbot/scenarioPaste', this.user.companyID)
        .then(() => {
          // 他のアカウントと同編集のばあいはリロードを促す
          this.$store.dispatch('virtualOffice/sendVirtualOfficeSV',
            '[RELOADSCENARIO]' + this.selectScenarioName
          )
        })
      this.closeContextMenu()
      console.debug('*** End *** scenarioPaste')
    },
    scenarioPastCancel () {
      console.debug('*** Start *** scenarioPastCancel')
      this.$store.dispatch('chatbot/scenarioPastCancel')
      this.closeContextMenu()
      console.debug('*** End *** scenarioPastCancel')
    },
    scenarioDuplicate () {
      console.debug('*** Start *** scenarioDuplicate')
      this.$store.dispatch('chatbot/scenarioDuplicate', this.user.companyID)
        .then(() => {
          // 他のアカウントと同編集のばあいはリロードを促す
          this.$store.dispatch('virtualOffice/sendVirtualOfficeSV',
            '[RELOADSCENARIO]' + this.selectScenarioName
          )
        })
      this.closeContextMenu()
      console.debug('*** End *** scenarioDuplicate')
    },
    startFlgSet () {
      this.$store.dispatch('chatbot/setStartFlgSet', this.user.companyID)
        .then(() => {
          // this.$store.dispatch('chatbot/storySet')
          // 他のアカウントと同編集のばあいはリロードを促す
          this.$store.dispatch('virtualOffice/sendVirtualOfficeSV',
            '[RELOADSCENARIO]' + this.selectScenarioName
          )
        })
      this.closeContextMenu()
    },
    async goalFlgSet () {
      const data = this.getUpdateModalScenario()
      try {
        await this.updateGoal(data)
        this.updateGoalState(data.scenario)
        this.closeContextMenu()
      } catch (e) {
        console.log(e)
      }
    },
    /** パーツセット入力設定 */
    setRoboPartsSetInputFlg () {
      const flagData = {
        robo_parts_set: this.selectRoboPartsSet,
        scenario: this.modalScenario
      }
      this.$store.dispatch('chatbot/setRoboPartsSetInputFlg', flagData)
      this.closeContextMenu()
    },
    /** パーツセット出力設定 */
    setRoboPartsSetOutputFlg () {
      const flagData = {
        robo_parts_set: this.selectRoboPartsSet,
        scenario: this.modalScenario
      }
      this.$store.dispatch('chatbot/setRoboPartsSetOutputFlg', flagData)
      this.closeContextMenu()
    },
    getUpdateModalScenario () {
      let scenario = this.$_.cloneDeep(this.modalScenario)
      scenario.is_cv = !scenario.is_cv
      const data = {
        companyid: this.user.companyID,
        scenario: scenario
      }
      return data
    },
    async updateGoal (data) {
      await this.$store.dispatch('chatbot/updateScenario', data)
    },
    updateGoalState (scenario) {
      this.$store.dispatch('chatbot/updateScenarioTable', scenario)
    },
    closeContextMenu () {
      console.debug('*** Start *** closeContextMenu')
      document.getElementById('context-menu').classList.remove('active')
      console.debug('*** End *** closeContextMenu')
    }
  }
}
</script>

<style scoped>
.not-copy {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
#context-menu {
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  display: none;
  list-style: none;
  position: absolute;
  z-index: 2147483647;
  background-color: white;
  border: thin solid #00654C;
  border-bottom-width: 0px;
}
#context-menu.active {
  display: block;
}
.close-button {
  position: absolute;
  top: -27px;
  left: 107px;
}
.menu-icon {
  width: 100%;
  padding: 8px 15px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/ContextMenuScenario.vue